import React,{useEffect} from "react";
import { useSelector,useDispatch } from "react-redux";
import { Drawer} from "@mui/material";
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";
import NewTemplateWizardModal from "../NewTemplateWizard/NewTemplateWizardModal";
import { styled } from '@mui/material/styles';

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: '100%',
    backgroundColor: 'transparent',
    boxShadow: "none"
  },
}));

export default function NewTemplateWizard({ modalOpen,toggle }) {
  const newTemplate = useSelector((state) => state.newTemplate);
  const dispatch = useDispatch()

  function onClose() {
    dispatch(newTemplateActions.resetState());
    toggle()
  }
  useEffect(() => {
    dispatch(newTemplateActions.setModalOpen(true));
  },[])
 
  return ( 
    <StyledDrawer
      anchor="left"
      open={newTemplate.modalOpen}
      onClose={onClose}
    >
      { newTemplate.modalOpen && <NewTemplateWizardModal toggle={toggle} /> }
      </StyledDrawer>
  );
}
